// no itx for this file
import Logger from "../Logger";
import { firstChildWithAtribute, firstChildWithTag } from "../components/XmlUtils";
import { enumAvailableLanguages } from "../models/SettingsEnums";

const logger = new Logger();

export default class KnxLanguageMapping {
  private mapping = new Map<string, any>();
  private mappingEN = new Map<string, any>();

  private languageId = "";
  private data: any;
  englishIsDefault = false;

  languageEN_notfound = false;

  reload(languageId: string) {
    this.load(this.data, languageId);
  }

  load(data: any, languageId: string) {
    this.data = data;

    if (this.mapping.size == 0 || this.languageId != languageId) {
      this.languageId = languageId;
      this.mapping = KnxLanguageMapping.loadIntern(data, languageId);
    }

    if (!this.languageEN_notfound && this.mappingEN.size == 0) {
      this.mappingEN = KnxLanguageMapping.loadIntern(data, "en-US");
      if (this.mappingEN.size == 0) {
        this.languageEN_notfound = true;
        //
        // das Produkt hat keine englische Übersetzung
        //
        //
      }
    }
  }

  private static loadIntern(data: any, languageId: string): Map<string, any> {
    const res = new Map<string, any>();

    logger.log(`load translation ${languageId}`);

    const KNX = data?.KNX;
    const ManufacturerData = firstChildWithTag(KNX, "ManufacturerData");
    const Manufacturer = firstChildWithTag(ManufacturerData, "Manufacturer");
    const Languages = firstChildWithTag(Manufacturer, "Languages");

    // <Language Identifier="de-DE">

    var language = firstChildWithAtribute(Languages, "Identifier", languageId);

    if (language == undefined) {
      // language is not in xml defined use defaultlanguage
      language = firstChildWithAtribute(Languages, "Identifier", enumAvailableLanguages.english);
    }

    if (language) {
      const TranslationUnit = firstChildWithTag(language, "TranslationUnit");

      if (TranslationUnit) {
        for (let i in TranslationUnit.items) {
          const translationElement = TranslationUnit.items[i];
          const tt: any = {};
          for (let j in translationElement.items) {
            const item = translationElement.items[j];
            const name: string = item.a.AttributeName as string;
            tt[name] = item.a.Text;
          }

          res.set(translationElement.a.RefId, tt);
          // logger.log(
          //   `load: ${translationElement.a.RefId} ${tt.Text} ${tt.FunctionText}`,
          // );
        }
      }
    }

    return res;
  }

  getTranslation(id: string | undefined, attribute: string): string | undefined {
    if (id) {
      const item = this.mapping.get(id);
      if (item) {
        return item[attribute];
      }
    }

    return undefined;
  }

  getTranslationEN(id: string | undefined, attribute: string): string | undefined {
    if (id) {
      const item = this.mappingEN.get(id);
      if (item) {
        return item[attribute];
      }
    }

    return undefined;
  }

  get hasTranslationEN() {
    return this.mappingEN.size > 0;
  }

  get isEmpty(): boolean {
    return this.mapping.size == 0;
  }

}
